/**
 * @created : 2021/3/31
 * @author  : 王冲
 * @desc    : mock数据 （模拟接口返回数据）
 */
import { getLabel } from "@weapp/utils";
import { canCreateTeams, isPrivateEnv, isSingleTenant, needShowIvite, needShowLogout, needShowTenant } from "../utils";

export const mockData = (): any => {
  return {
    unfinishedCount: 99,
    watchCount: 165,
    empMenusContext: [
      {
        module: "task",
        menuname: getLabel('62289', "任务"),
        id: "1",
        icon: "Icon-Approval-process-o",
        path: "/task",
      },
      {
        module: "doc",
        menuname: getLabel('62290', "文档"),
        id: "1",
        icon: "Icon-Approval-process-o",
        path: "/doc",
      },
      {
        module: "mainline",
        menuname: getLabel('62291', "项目"),
        id: "1",
        icon: "Icon-Approval-process-o",
        path: "/project",
      },
      {
        module: "formreport",
        menuname: getLabel('62292', "表单"),
        id: "1",
        icon: "Icon-Approval-process-o",
        path: "/formreport",
      },
    ],

    sideMenusData: [
      {
        id: "tab1",
        content: getLabel('62289', "任务"),
        children: [
          { id: "childTab1_1", content: getLabel('62293', "关注的任务") },
          { id: "childTab1_2", content: getLabel('62294', "共享给我的任务") },
          { id: "childTab1_3", content: getLabel('62295', "已完成的任务") },
          { id: "childTab1_4", content: getLabel('62294', "共享给我的任务") },
          { id: "childTab1_5", content: getLabel('62296', "全部任务") },
        ],
      },
      { id: "tab2", content: getLabel('62297', "待批任务") },
      { id: "tab3", content: getLabel('62298', "任务评论") },
      {
        id: "tab4",
        content: getLabel('62299', "任务统计"),
        children: [
          { id: "childTab4_1", content: getLabel('62300', "任务统计报表") },
          { id: "childTab4_2", content: getLabel('62301', "任务完成情况") },
          { id: "childTab4_3", content: getLabel('62302', "自定义字段统计") },
        ],
      },
      { id: "tab6", content: getLabel('28576', "回收站") },
    ],

    createMenus: [
      [
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61779', "写日报"),
          action: "create-blog",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61780', "安排任务"),
          action: "create-task",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61781', "安排日程"),
          action: "create-agenda",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('15035', "上传文件"),
          action: "create-doc",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('11473', "提交申请"),
          action: "create-flow",
        },
        {
          name: getLabel('61783', "添加项目"),
          icon: "Icon-Approval-process-o",
          tactionype: "create-project",
        },
      ],
      [
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61784', "新建客户"),
          action: "create-customer",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61786', "新建联系人"),
          action: "create-contacts",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61787', "客户联系记录"),
          action: "create-record",
        },
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('61794', "新建订单"),
          action: "create-orderform",
        },
      ],
      [
        {
          icon: "Icon-Approval-process-o",
          name: getLabel('19210', "设置"),
          action: "create-set",
        },
      ],
    ],

    quickMenus: [
      [
        {
          name: getLabel('62170', "企业微信及终端"),
          module: "quick_client",
          hidden: !!(window.TEAMS?.deploy === 'private')
        },
        {
          name: getLabel('13765', "微信号"),
          module: "quick_wechat",
          hidden: !!(window.TEAMS?.deploy === 'private')
        },
        {
          name: getLabel('62303', "添加和邀请同事"),
          module: "quick_invite",
          hidden: !needShowIvite()
        },
        {
          name: getLabel('62169', "创建或加入团队"),
          module: "quick_team",
          hidden: !needShowTenant() || (isPrivateEnv() && !canCreateTeams())
        },
      ],
      [
        {
          name: getLabel('14801', "通讯录"),
          module: "quick_contact",
        },
        {
          name: getLabel('69854', '组织架构设置'),
          module: "quick_org",
        },
      ],
      [
        {
          name: getLabel('62305', "个人设置"),
          module: "quick_profile",
          hidden: !!(window.TEAMS?.currentUser?.detachadmin === "1")
        },
        {
          name: getLabel('61389', "后台管理中心"),
          module: "quick_manager",
        },
        {
          name: getLabel('85197', '导入导出记录'),
          module: "quick_importAndExport",
          // hidden: true
          // hide: !window.TEAMS?.currentUser?.admin
        },
      ],
      [
        {
          name: getLabel('62306', "切换导航"),
          module: "quick_changeNav",
        },
      ],
      [
        {
          name: getLabel('62171', "推荐拿福利"),
          module: "quick_goods",
          hidden: !!(window.TEAMS?.deploy === 'private')
        },
      ],
      [
        {
          name: getLabel('62172', "清除缓存"),
          module: "quick_clean",
        },
        {
          name: getLabel('62307', "退出系统"),
          module: "quick_logout",
          hidden: !needShowLogout()
        },
      ],
    ],
    appList: [
      [
        {
          groupName: getLabel('20938', "汇报"),
          menus: [
            {
              id: "6",
              module: "blog",
              menuname: getLabel('62308', "工作日报"),
              icon: "",
              path: "/blog",
            },
            {
              id: "8",
              module: "workreport",
              menuname: getLabel('18272', "计划报告"),
              icon: "",
              path: "/workreport",
            },
            {
              id: "21",
              module: "saleTarget",
              menuname: "OKR",
              icon: "",
              path: "/crm/saleTarget",
            },
          ],
        },
        {
          groupName: getLabel('62310', "协作"),
          menus: [
            {
              id: "3",
              module: "mainline",
              menuname: getLabel('62311', "项目管理"),
              icon: "",
              path: "/project",
            },
            {
              id: "1",
              module: "task",
              menuname: getLabel('62312', "任务协作"),
              icon: "",
              path: "/task",
            },
            {
              id: "7",
              module: "calendar",
              menuname: getLabel('62313', "日程安排"),
              icon: "",
              path: "/calendar",
            },
            {
              id: "4",
              module: "document",
              menuname: getLabel('62314', "知识文档"),
              icon: "",
              path: "/doc",
            },
            {
              id: "39",
              module: "signcontract",
              menuname: getLabel('62316', "电子签"),
              icon: "",
              path: "/signcontract",
            },
          ],
        },
        {
          groupName: "HRM",
          menus: [
            {
              id: "31",
              module: "kpi",
              menuname: getLabel('62317', "绩效考核"),
              icon: "",
              path: "/hrs",
            },
            {
              id: "30",
              module: "hr",
              menuname: getLabel('62318', "人事档案"),
              icon: "",
              path: "/hrm",
            },
            {
              id: "17",
              module: "attend",
              menuname: getLabel('62319', "出勤"),
              icon: "",
              path: "/attend",
            },
            {
              id: "25",
              module: "salarybill",
              menuname: getLabel('62320', "工资单"),
              icon: "",
              path: "/salarybill",
            },
          ],
        },
      ],
      [
        {
          groupName: getLabel('62321', "审批"),
          menus: [
            {
              id: "2",
              module: "workflow",
              menuname: getLabel('62322', "审批流程"),
              icon: "",
              path: "/workflow",
            },
          ],
        },
        {
          groupName: getLabel('62323', "数据协作"),
          menus: [
            {
              id: "11",
              module: "form",
              menuname: getLabel('62324', "业务表单"),
              icon: "",
              path: "/forms",
            },
          ],
        },
        {
          groupName: getLabel('13680', "其他"),
          menus: [
            {
              id: "9",
              module: "statisticalReport",
              menuname: getLabel('32033', "统计报表"),
              icon: "",
              path: "/report",
            },
            {
              id: "18",
              module: "sms",
              menuname: getLabel('62326', "短信"),
              icon: "",
              path: "/bulksms",
            },
            {
              id: "29",
              module: "mail",
              menuname: getLabel('62329', "邮件"),
              icon: "",
              path: "/mail",
            },
            {
              id: "35",
              module: "tag",
              menuname: getLabel('11640', "标签"),
              icon: "",
              path: "/tag",
            },
            {
              id: "10",
              module: "wechatEnterprise",
              menuname: getLabel('32663', "企业微信"),
              icon: "",
              path: "/info/wechat",
            },
            {
              id: "13",
              module: "wechatService",
              menuname: getLabel('62331', "微信服务号"),
              icon: "",
              path: "/info/wechatservice",
            },
            {
              id: "26",
              module: "placard",
              menuname: getLabel('62333', "通知公告"),
              icon: "",
              path: "/placard",
            },
            {
              id: "37",
              module: "room",
              menuname: getLabel('62334', "会议室管理"),
              icon: "",
              path: "/room/schedule",
            },
            {
              id: "40",
              module: "invoice",
              menuname: getLabel('62286', "发票助手"),
              icon: "",
              path: "/invoice",
            },
          ],
        },
      ],
      [
        {
          groupName: "CRM",
          menus: [
            {
              id: "23",
              module: "marketactivity",
              menuname: getLabel('62335', "市场活动"),
              icon: "",
              path: "/crm/marketactivity",
            },
            {
              id: "19",
              module: "clue",
              menuname: getLabel('28908', "线索"),
              icon: "",
              path: "/crm/clue",
            },
            {
              id: "5",
              module: "customer",
              menuname: getLabel('62336', "客户"),
              icon: "",
              path: "/crm/customer",
            },
            {
              id: "12",
              module: "contact",
              menuname: getLabel('60599', "联系人"),
              icon: "",
              path: "/crm/contact",
            },
            {
              id: "14",
              module: "saleChance",
              menuname: getLabel('62337', "商机"),
              icon: "",
              path: "/crm/saleChance",
            },
            {
              id: "20",
              module: "contract",
              menuname: getLabel('62338', "合同"),
              icon: "",
              path: "/crm/contract",
            },
            {
              id: "33",
              module: "orderform",
              menuname: getLabel('62339', "订单"),
              icon: "",
              path: "/crm/orderform",
            },
            {
              id: "34",
              module: "price",
              menuname: getLabel('31922', "价格"),
              icon: "",
              path: "/crm/price",
            },
            {
              id: "36",
              module: "capital",
              menuname: getLabel('62342', "资金"),
              icon: "",
              path: "/crm/capital",
            },
            {
              id: "38",
              module: "quote",
              menuname: getLabel('62343', "报价"),
              icon: "",
              path: "/crm/quote",
            },
            {
              id: "15",
              module: "production",
              menuname: getLabel('29329', "产品"),
              icon: "",
              path: "/crm/production",
            },
            {
              id: "16",
              module: "competitor",
              menuname: getLabel('62344', "竞争对手"),
              icon: "",
              path: "/crm/competitor",
            },
            {
              id: "22",
              module: "crmSummary",
              menuname: getLabel('62346', "CRM统计"),
              icon: "",
              path: "/crm/crmSummary",
            },
          ],
        },
      ],
      [
        {
          groupName: getLabel('11662', "自定义"),
          menus: [
            {
              id: "5139187787647323173",
              module: "freeForm",
              menuname: getLabel('62347', "云规则应用"),
              icon: "",
              path: "/free/5139187787647323173",
            },
            {
              id: "5139187787748423177",
              module: "freeForm",
              menuname: getLabel('62348', "多表规则2018"),
              icon: "",
              path: "/free/5139187787748423177",
            },
            {
              id: "5139187787806323181",
              module: "freeForm",
              menuname: getLabel('62349', "请假管理"),
              icon: "",
              path: "/free/5139187787806323181",
            },
            {
              id: "5139187787846323185",
              module: "freeForm",
              menuname: getLabel('62351', "外出管理"),
              icon: "",
              path: "/free/5139187787846323185",
            },
            {
              id: "5139187787912223189",
              module: "freeForm",
              menuname: getLabel('62352', "报销管理"),
              icon: "",
              path: "/free/5139187787912223189",
            },
            {
              id: "5139187787954723193",
              module: "freeForm",
              menuname: getLabel('62353', "借款管理"),
              icon: "",
              path: "/free/5139187787954723193",
            },
          ],
        },
      ],
    ],

    mobileAppList: [
      {
        groupName: getLabel('62505', '门户'),
        menus: [
          {
            id: "66",
            module: "portal",
            menuname: getLabel('62354', "移动门户"),
            description: getLabel('62356', "系统默认的自定义移动门户"),
            icon: "",
            path: "/portal",
          },
        ],
      },
      {
        groupName: getLabel('20938', "汇报"),
        menus: [
          {
            id: "6",
            module: "blog",
            menuname: getLabel('62308', "工作日报"),
            description: getLabel('62357', "记录每一天的工作成果和心得经验"),
            icon: "",
            path: "/mobile/blog",
          },
          {
            id: "8",
            module: "workreport",
            menuname: getLabel('18272', "计划报告"),
            icon: "",
            description: getLabel('62359', "每周、每月、每年的周期性工作汇报"),
            path: "/mobile/workreport",
          },
        ],
      },
      {
        groupName: getLabel('62310', "协作"),
        menus: [
          {
            id: "3",
            module: "mainline",
            menuname: getLabel('62311', "项目管理"),
            description: getLabel('62360', "围绕周期目标，提升团队协作效率"),
            icon: "",
            path: "/mobile/project",
          },
          {
            id: "1",
            module: "task",
            menuname: getLabel('62312', "任务协作"),
            description: getLabel('62361', "快速安排任务，并实时反馈任务进度"),
            icon: "",
            path: "/mobile/task",
          },
          {
            id: "7",
            module: "calendar",
            menuname: getLabel('62313', "日程安排"),
            icon: "",
            description: getLabel('62363', "建立个人的Todolist及时间安排"),
            path: "/mobile/calendar",
          },
          {
            id: "4",
            module: "document",
            menuname: getLabel('62314', "知识文档"),
            icon: "",
            description: getLabel('62364', "团队统一知识库，沉淀工作成果经验"),
            path: "/mobile/doc",
          },
          {
            id: "39",
            module: "signcontract",
            menuname: getLabel('62316', "电子签"),
            description: getLabel('62366', "管理和记录每一份电子签信息"),
            icon: "",
            path: "/mobile/signcontract",
          },
        ],
      },
      {
        groupName: "HRM",
        menus: [
          {
            id: "31",
            module: "kpi",
            menuname: getLabel('62317', "绩效考核"),
            icon: "",
            description: getLabel('227183', "设置和管理组织成员的绩效考核信息"),
            path: "/mobile/hrs",
          },
          {
            id: "30",
            module: "hr",
            menuname: getLabel('62318', "人事档案"),
            icon: "",
            path: "/mobile/hrm",
          },
          {
            id: "17",
            module: "attend",
            menuname: getLabel('62319', "出勤"),
            description: getLabel('62370', "体验移动互联下的上下班签到"),
            icon: "",
            path: "/mobile/attend",
          },
        ],
      },
      {
        groupName: getLabel('62321', "审批"),
        menus: [
          {
            id: "2",
            module: "workflow",
            menuname: getLabel('62322', "审批流程"),
            icon: "",
            description: getLabel('62372', "加班、请假、报销申请等的移动审批"),
            path: "/mobile/workflows",
          },
        ],
      },
      {
        groupName: getLabel('62323', "数据协作"),
        menus: [
          {
            id: "11",
            module: "form",
            menuname: getLabel('62324', "业务表单"),
            icon: "",
            description: getLabel('62373', "问卷调查、表单数据记录等场景应用"),
            path: "/mobile/forms",
          },
        ],
      },
      {
        groupName: getLabel('13680', "其他"),
        menus: [
          {
            id: "18",
            module: "sms",
            menuname: getLabel('62326', "短信"),
            description:
              getLabel('227184', "通过eteams平台向组织成员或客户发送手机短信，支持群发、定时发送、定制化发送等功能，使系统消息通知更加及时便捷"),
            icon: "",
            path: "/mobile/bulksms",
          },
          {
            id: "29",
            module: "mail",
            menuname: getLabel('62329', "邮件"),
            description:
              getLabel('62376', "通过eteams邮件客户端，可以更高效，更轻松处理邮件，并且与系统其他模块更好的关联"),
            icon: "",
            path: "/mobile/mail",
          },
          {
            id: "26",
            module: "placard",
            menuname: getLabel('62333', "通知公告"),
            description: getLabel('62378', "统一传达团队最新动态及要求"),
            icon: "",
            path: "/mobile/placard",
          },
          {
            id: "37",
            module: "room",
            menuname: getLabel('62379', "会议室"),
            icon: "",
            description: getLabel('227185', "管理组织会议室"),
            path: "/mobile/room",
          },
        ],
      },
      {
        groupName: "CRM",
        menus: [
          {
            id: "5",
            module: "crmHome",
            menuname: getLabel('14161', "首页"),
            description: getLabel('62382', "一览CRM关键数据"),
            icon: "",
            path: "/mobile/crm/home",
          },
          {
            id: "5",
            module: "customer",
            menuname: getLabel('62336', "客户"),
            description: getLabel('62383', "推进客户的每一步跟踪及下一步联络"),
            icon: "",
            path: "/mobile/crm/customer",
          },
          {
            id: "23",
            module: "marketactivity",
            menuname: getLabel('62335', "市场活动"),
            description: getLabel('62385', "统一管理公司活动"),
            icon: "",
            path: "/mobile/crm/marketactivity",
          },
          {
            id: "19",
            module: "clue",
            menuname: getLabel('28908', "线索"),
            description: getLabel('62387', "收集每一次市场行为带来的客户商机"),
            icon: "",
            path: "/mobile/crm/clue",
          },
          {
            id: "12",
            module: "contact",
            menuname: getLabel('60599', "联系人"),
            description: getLabel('62388', "我的联系人名单"),
            icon: "",
            path: "/mobile/crm/contact",
          },
          {
            id: "14",
            module: "saleChance",
            menuname: getLabel('62337', "商机"),
            description: getLabel('62390', "聚焦每个客户的销售机会，促成订单"),
            icon: "",
            path: "/mobile/crm/saleChance",
          },
          {
            id: "20",
            module: "contract",
            menuname: getLabel('62338', "合同"),
            description: getLabel('62391', "记录每份订单合同并跟踪回款开票信息"),
            icon: "",
            path: "/mobile/crm/contract",
          },
          {
            id: "33",
            module: "orderform",
            menuname: getLabel('62339', "订单"),
            description: getLabel('62393', "记录每份订单并跟踪状态回款开票等信息"),
            icon: "",
            path: "/mobile/crm/orderform",
          },
          {
            id: "34",
            module: "price",
            menuname: getLabel('31922', "价格"),
            description: getLabel('227186', "维护价目表信息"),
            icon: "",
            path: "/mobile/crm/price",
          },
          {
            id: "36",
            module: "capital",
            menuname: getLabel('62342', "资金"),
            description: getLabel('62395', "维护客户资金账户信息"),
            icon: "",
            path: "/mobile/crm/capital",
          },
          {
            id: "38",
            module: "quote",
            menuname: getLabel('62343', "报价"),
            description: getLabel('227187', "维护报价信息"),
            icon: "",
            path: "/mobile/crm/quote",
          },
          {
            id: "15",
            module: "production",
            menuname: getLabel('29329', "产品"),
            description: getLabel('62398', "集中管理团队的业务销售产品"),
            icon: "",
            path: "/mobile/crm/production",
          },
          {
            id: "16",
            module: "competitor",
            menuname: getLabel('62344', "竞争对手"),
            description: getLabel('62399', "分享及学习行业友商的优劣势"),
            icon: "",
            path: "/mobile/crm/competitor",
          },
        ],
      },
      {
        groupName: getLabel('11662', "自定义"),
        menus: [
          {
            id: "5139187787647323173",
            module: "freeForm",
            menuname: getLabel('62347', "云规则应用"),
            description: getLabel('62401', "应用描述..."),
            icon: "",
            path: "/mobile/free/5139187787647323173",
          },
          {
            id: "5139187787748423177",
            module: "freeForm",
            menuname: getLabel('62348', "多表规则2018"),
            description: getLabel('62402', "应用描述.."),
            icon: "",
            path: "/mobile/free/5139187787748423177",
          },
          {
            id: "5139187787806323181",
            module: "freeForm",
            menuname: getLabel('62349', "请假管理"),
            description: getLabel('62402', "应用描述.."),
            icon: "",
            path: "/mobile/free/5139187787806323181",
          },
          {
            id: "5139187787846323185",
            module: "freeForm",
            menuname: getLabel('62351', "外出管理"),
            description: getLabel('62402', "应用描述.."),
            icon: "",
            path: "/mobile/free/5139187787846323185",
          },
          {
            id: "5139187787912223189",
            module: "freeForm",
            menuname: getLabel('62352', "报销管理"),
            description: getLabel('62402', "应用描述.."),
            icon: "",
            path: "/mobile/free/5139187787912223189",
          },
          {
            id: "5139187787954723193",
            module: "freeForm",
            menuname: getLabel('62353', "借款管理"),
            description: getLabel('62402', "应用描述.."),
            icon: "",
            path: "/mobile/free/5139187787954723193",
          },
        ],
      },
    ],
    mobCreateMenus: [
      [{
        module: "blog",
        name: getLabel('61779', "写日报"),
        path: "/mobile/blog/current",
      },
      {
        module: "task",
        name: getLabel('61780', "安排任务"),
        path: "/mobile/task/taskDetail/create",
      },
      {
        module: "calendar",
        name: getLabel('61781', "安排日程"),
        path: "/mobile/calendar/detail/create",
      },
      {
        module: "document",
        name: getLabel('15035', "上传文件"),
        path: "/mobile/doc/mobileUploadFile/document/300",
      },
      {
        module: "workflow",
        name: getLabel('11473', "提交申请"),
        path: "/mobile/workflow/newflow",
      },
      {
        name: getLabel('61783', "添加项目"),
        module: "mainline",
        path: "/mobile/project/details/create",
      }, {
        module: "attend",
        name: getLabel('62319', "出勤"),
        path: "/mobile/attend",
      },
      {
        module: "customer",
        name: getLabel('61784', "新建客户"),
        path: "/mobile/crm/customer/0/addCustomer",
      },
      {
        module: "contact",
        name: getLabel('61786', "新建联系人"),
        path: "/mobile/crm/contact/0/addContact",
      },
      {
        module: "saleChance",
        name: getLabel('61792', "新建商机"),
        path: "/mobile/crm/saleChance/0/addSaleChance",
      },
      {
        module: "competitor",
        name: getLabel('60949', "新建对手"),
        path: "/mobile/crm/competitor/0/addCompetitor",
      },
      {
        module: "marketactivity",
        name: getLabel('62404', "新建活动"),
        path: "/mobile/crm/marketActivity/0/addMarketActivity",
      },
      {
        module: "contract",
        name: getLabel('61793', "新建合同"),
        path: "/mobile/crm/contract/0/addContract",
      },
      {
        module: "clue",
        name: getLabel('61790', "新建线索"),
        path: "/mobile/crm/clue/0/addClue",
      },
      {
        module: "quote",
        name: getLabel('62405', "新建报价"),
        path: "/mobile/crm/quote/0/addQuote",
      },
      {
        module: "placard",
        name: getLabel('61798', "发布公告"),
        path: "/mobile/placard/page",
      }]],
  };
}

